import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/rest-pki`

    return {
        start(params) {
            return repository.post(`${baseUrl}/start`, params)
        },
        finish(params) {
            return repository.post(`${baseUrl}/finish`, params)
        },
    }
}